import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import ClipLoader from "react-spinners/ClipLoader"; 


import axiosClient from "../../api/axios";


export default function WhyParticipate() {
  
  const [homeWhyParticipate, setHomeWhyParticipate] = useState(null);
  const [loadingHomeWhyParticipate, setLoadingHomeWhyParticipate] = useState(true);

  useEffect(() => {
    const fetchHomeWhyParticipate = async () => {
      try {
        const response = await axiosClient.get(`/api/home-why-participate/`);
        setHomeWhyParticipate(response.data.data);
      } catch (error) {
        console.error("Failed to fetch study:", error);
      } finally {
        setLoadingHomeWhyParticipate(false);
      }
    };

    fetchHomeWhyParticipate();
  }, []);

  if (loadingHomeWhyParticipate) {
    return (
      <section
        className="about-us ptb-100 gray-light-bg"
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          minHeight: "60vh",
        }}
      >
        <ClipLoader color="#0d6efd" size={80} />
      </section>
    );
  }

  return (
    <>
      <section id="about" className="about-us ptb-100 gray-light-bg">
        <div className="container">
          <div className="row align-items-center justify-content-between">
            <div className="col-md-6">
              <div className="about-content-left section-heading">
                <span className="text-uppercase color-secondary sub-title">
                  {homeWhyParticipate?.question}
                </span>
                <h2>{homeWhyParticipate?.title}</h2>

                {homeWhyParticipate?.sections?.map((data) => (
                  <div key={data.id} className="single-feature mb-4">
                    <div className="d-flex align-items-center mb-2">
                      <span
                        className={`${data?.icon} rounded mr-3 icon ${data.icon_bg_color}`}
                      ></span>
                      <h5 className="mb-0">{data?.title}</h5>
                    </div>
                    <p>{data?.description}</p>
                  </div>
                ))}

                <Link
                  className="btn solid-btn mt-2"
                  to={"/contact-us"}
                >
                  {homeWhyParticipate?.button}
                </Link>
              </div>
            </div>
            <div className="col-md-6">
              <div className="about-content-right">
                <img
                  src={homeWhyParticipate?.image_url}
                  alt="about us"
                  className="img-fluid"
                />
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
